var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"btn btn-success btn-wd",on:{"click":function($event){$event.preventDefault();return _vm.apply_action()}}},[_vm._v(" "+_vm._s(_vm.action_data.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }